// Configuração do Google Maps
const getApiKey = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
  
  if (!apiKey) {
    console.warn('⚠️ REACT_APP_GOOGLE_MAPS_API_KEY não está configurada. Configure a variável de ambiente.');
    console.warn('⚠️ Verifique se a variável está definida no arquivo .env ou nas variáveis de ambiente do servidor.');
  } else {
    console.log('✅ Google Maps API Key configurada (primeiros 10 caracteres):', apiKey.substring(0, 10) + '...');
  }
  
  return apiKey;
};

export const GOOGLE_MAPS_CONFIG = {
  apiKey: getApiKey(),
  libraries: ['places', 'marker'],
  region: 'BR',
  language: 'pt-BR'
};

export const MAP_CENTER = {
  lat: -26.9903,
  lng: -48.6346
};

export const MAP_OPTIONS = {
  center: MAP_CENTER,
  zoom: 15,
  styles: [
    {
      featureType: 'all',
      elementType: 'geometry.fill',
      stylers: [{ color: '#f8f9fa' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [{ color: '#e3f2fd' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#1976d2' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#e0e0e0' }]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#424242', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif' }]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#d0d0d0' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#333333', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: '600' }]
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [{ color: '#f5f5f5' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#616161', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#424242', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif' }]
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [{ color: '#f8f9fa' }]
    },
    {
      featureType: 'transit',
      elementType: 'geometry.fill',
      stylers: [{ color: '#ffffff' }]
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#616161', fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif' }]
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#ffffff' }]
    }
  ]
};
